import { Routes, Route, Navigate } from 'react-router-dom';
import LoginLayout from '@copilot/common/pages/layouts/login';
import RouteWithPermissions from '@copilot/common/router/routeWithPermissions';
import { UserRoleGroups } from '@copilot/common/config/roles';
import LoginPage from '@copilot/common/pages/login';
import BaseLayout from '@copilot/common/pages/layouts/base';
import BaseSidebar from '../components/menus/sidebar';
import { CsHeader } from '@copilot/cs/src/components/menus/header/csHeader';
import CategorizePage from '../pages/categorize';
import withImpersonation from '../pages/customer/withImpersonation';
import { OldCampaignDetails } from '@copilot/common/pages/campaignDashboard';
import { Config } from '@copilot/common/config';
import TeamCustomersPage from '../pages/customers/teams';
import TeamDashboard from '../pages/customer/teams';
import { EnvironmentType } from '../components/menus/header/constant';
import BillingPage from '@copilot/cs/src/pages/customerDetails/billing';
import CustomerDetailsLayout from '@copilot/cs/src/pages/customerDetails/ui/layout';
import ChangeSubscriptionWizard from '@copilot/cs/src/pages/customerDetails/billing/edit';
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
} from '@copilot/common/utils/authenticationProvider';
import B2CSignUpPage from '@copilot/common/pages/b2csignup';

const CampaignDashboard = withImpersonation(OldCampaignDetails);
const TeamDashboardPage = withImpersonation(TeamDashboard);
const CsRouter = () => {
    return (
        <Routes>
            <Route
                path="/signup"
                element={
                    <LoginLayout>
                        <RouteWithPermissions
                            element={<B2CSignUpPage />}
                            allowedRoles={UserRoleGroups.Guest}
                            roleRedirectTo="/"
                        />
                    </LoginLayout>
                }
            />
            <Route
                path="/login"
                element={
                    <UnauthenticatedTemplate>
                        <LoginLayout>
                            <RouteWithPermissions
                                element={<LoginPage hidePwdRecovery />}
                                allowedRoles={UserRoleGroups.Guest}
                                roleRedirectTo="/"
                            />
                        </LoginLayout>
                    </UnauthenticatedTemplate>
                }
            />
            <Route
                path="/*"
                element={
                    <AuthenticatedTemplate>
                        <BaseLayout>
                            <BaseLayout.Header>
                                <CsHeader
                                    environmentType={EnvironmentType.AGENCY}
                                    showProfile={false}
                                    showSettings
                                    isCalendly={true}
                                />
                            </BaseLayout.Header>
                            <BaseLayout.Sidebar>
                                <BaseSidebar />
                            </BaseLayout.Sidebar>
                            <BaseLayout.Content>
                                <Routes>
                                    <Route
                                        path="/"
                                        element={
                                            <RouteWithPermissions
                                                element={<TeamCustomersPage />}
                                                allowedRoles={UserRoleGroups.Admin}
                                            />
                                        }
                                    />
                                    <Route
                                        path="/customer/:oid/:omid/campaign/:campaignId?"
                                        element={
                                            <RouteWithPermissions
                                                element={<CampaignDashboard />}
                                                allowedRoles={UserRoleGroups.Admin}
                                            />
                                        }
                                    />
                                    <Route
                                        path="/teams/:oid/:omid?"
                                        element={
                                            <RouteWithPermissions
                                                element={<TeamDashboardPage />}
                                                allowedRoles={UserRoleGroups.Admin}
                                            />
                                        }
                                    />
                                    {!Config.isAgency && (
                                        <Route
                                            path="/categorize"
                                            element={
                                                <RouteWithPermissions
                                                    element={<CategorizePage />}
                                                    allowedRoles={UserRoleGroups.VirtualAssistant}
                                                />
                                            }
                                        />
                                    )}
                                    <Route path="*" element={<Navigate to="/" replace />} />
                                </Routes>
                            </BaseLayout.Content>
                        </BaseLayout>
                    </AuthenticatedTemplate>
                }
            />
            <Route
                path="/details/:orgMemberId/billing"
                element={
                    <CustomerDetailsLayout
                        includeSidebar
                        getHeaderTitle={() => 'Customers'}
                        getBackUrl={() => '/'}
                    >
                        <AuthenticatedTemplate>
                            <Routes>
                                <Route
                                    path="/details/:orgMemberId/billing"
                                    element={
                                        <RouteWithPermissions
                                            element={<BillingPage />}
                                            allowedRoles={UserRoleGroups.Admin}
                                        />
                                    }
                                />
                            </Routes>
                        </AuthenticatedTemplate>
                    </CustomerDetailsLayout>
                }
            />
            <Route
                path="/details/:orgMemberId/billing/edit"
                element={
                    <CustomerDetailsLayout confirmOnLeave>
                        <AuthenticatedTemplate>
                            <Routes>
                                <Route
                                    path="/details/:orgMemberId/billing/edit"
                                    element={
                                        <RouteWithPermissions
                                            element={<ChangeSubscriptionWizard />}
                                            allowedRoles={UserRoleGroups.Admin}
                                        />
                                    }
                                />
                            </Routes>
                        </AuthenticatedTemplate>
                    </CustomerDetailsLayout>
                }
            />
        </Routes>
    );
};

export default CsRouter;
